
import { on } from 'delegated-events';
import helpers from './helpers';

export default (function () {
  return {
    init() {
      const breadcrumb = document.querySelector('.breadcrumb');
      if (breadcrumb === null) return;

      const breadcrumbItems = breadcrumb.querySelector('.breadcrumb__items');

      if (breadcrumbItems.offsetWidth > 120) {
        breadcrumbItems.classList.add('is-truncated');
        on('click', '.breadcrumb__items', (e) => {
          if (e.currentTarget.classList.contains('is-truncated') && helpers.breakpoint() === 'mobile') {
            e.preventDefault();
            breadcrumbItems.classList.remove('is-truncated');
            breadcrumbItems.classList.add('is-untruncated');
          }
        });
      }
    },
  };
}());
